import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M866.331875 213L866.331875 866.331875 213 866.331875 213 1052.99813 866.331875 1052.99813 866.331875 1706.33 1052.99813 1706.33 1052.99813 1052.99813 1706.33 1052.99813 1706.33 866.331875 1052.99813 866.331875 1052.99813 213z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconGroupNewSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconGroupNewSolid, _Component);

  var _super = _createSuper(IconGroupNewSolid);

  function IconGroupNewSolid() {
    _classCallCheck(this, IconGroupNewSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconGroupNewSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconGroupNew",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconGroupNewSolid.displayName = "IconGroupNewSolid";
  return IconGroupNewSolid;
}(Component);

IconGroupNewSolid.glyphName = 'group-new';
IconGroupNewSolid.variant = 'Solid';
IconGroupNewSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconGroupNewSolid;
export { IconGroupNewSolid };